export default __webpack_public_path__ + "static/media/bidifylogo_avax.3aff675b.png";